import styled from 'styled-components';
import PhoneInput from './PhoneInput';

export default styled(PhoneInput)`
  .phone-input {
    height: 38px;
    position: relative;

    &__phone-label {
      font-size: 1.2rem;
      color: var(--greyGorilla);
      pointer-events: none;
      position: absolute;
      display: inline-flex;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 3;
      height: 100%;
      padding: 0.8rem 0.8rem 0.8rem 4.5rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      transition: all 0.2s;

      &--filled {
        font-size: 1rem;
        transform: translate(0, -20%);
      }
    }

    &__phone {
      height: 100%;
      border: ${(props) => (props.error ? `1px solid var(--redCherry)` : '0')};
    }

    input.phone-input__phone-input {
      background: ${(props) => (props.error ? 'var(--redWattermelon)' : 'var(--white)')};
      border-radius: 0;
      height: 100%;
      padding-top: 1.6rem;
      padding-right: 0.8rem;
      padding-bottom: 0.2rem;
      width: 100%;

      &:focus {
        .phone-input__phone-label {
          font-size: 1rem;
          transform: translate(94%, -24%);
        }
      }
    }

    &__phone-button {
      border-radius: 0;
      height: 100%;
    }
  }
`;
